import { camelizeKeys, decamelizeKeys } from 'humps'

import { authedFetch } from '~/utils/fetch'
import HTTPError from '~/utils/http-error'
import { reportGroupedError } from '~/utils/logger'

export async function customerApiFetch(
  url: string,
  options: Record<string, any> = {},
  unauthorizedRedirectPath?: string,
) {
  try {
    const response = await authedFetch(url, options, unauthorizedRedirectPath)

    if ([204, 404].includes(response.status)) {
      return
    } else if (response.status === 422) {
      const { errors } = await response.json()
      throw camelizeKeys(errors)
    } else if (response.ok) {
      const { data } = await response.json()
      return camelizeKeys(data)
    } else {
      const text = await response.text()
      throw new HTTPError('fetch failed', response, text)
    }
  } catch (error) {
    if (['HTTPError', 'TypeError'].includes(error.name)) {
      reportGroupedError(url, error)
    }
    throw error
  }
}

export const customerApiPatch = (path, { arg: data }) =>
  customerApiFetch(path, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: decamelizeKeys(data) }),
  })

export const customerApiPost = (path, { arg: data }) =>
  customerApiFetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: decamelizeKeys(data) }),
  })

export const customerApiPut = (path, { arg: data }) =>
  customerApiFetch(path, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: decamelizeKeys(data) }),
  })
